export const PRICING_TIERS = {
  min: 10,
  max: 50,
  basePrice: 24000, // $240.00 per page in cents
  tiers: [
    { min: 1, max: 50, price: 24000 }, // $240 per page
    { min: 51, max: Infinity, price: 24000 } // Keep the same price for consistency
  ]
} as const;

export const STRIPE_PRODUCTS = {
  SERVICE_PLAN: {
    priceId: 'price_1RD8B7J5ZVoET6qOOZBwj30G',
    name: 'Service Plan',
    description: 'Full access to all features and services',
    mode: 'subscription' as const,
  },
} as const;

export function calculatePrice(quantity: number): number {
  if (quantity < PRICING_TIERS.min || quantity > PRICING_TIERS.max) {
    throw new Error(`Quantity must be between ${PRICING_TIERS.min} and ${PRICING_TIERS.max}`);
  }

  const tier = PRICING_TIERS.tiers.find(t => quantity >= t.min && quantity <= t.max);
  if (!tier) {
    throw new Error('Invalid quantity for pricing tiers');
  }

  return tier.price * quantity;
}
